export const prepareCrossData = (crossServicesConfigurations) => {
  return crossServicesConfigurations.reduce((acc, d) => {
    return {
      ...acc,
      [d.service_block_id]: {
        ...acc[d.service_block_id],
        [d.block_id]: {
          dependencies: d.dependencies,
          calculation: d.calculation,
          service_block_id: d.service_block_id,
          block_id: d.block_id,
          service_id: d.service_id,
          version: d.version,
          flg_output_visibility: d.flg_output_visibility,
          active: d.active,
        },
      },
    }
  }, {});
}